const getDefaultState = () => {
  return {
    surveys: [],
    selectedSurvey: null
  };
};

const state = getDefaultState();

const getters = {
  surveys (state) {
    return state.surveys;
  },
  selectedSurvey (state) {
    return state.selectedSurvey;
  }
};

const mutations = {
  setSurvey (state, payload) {
    state.selectedSurvey = payload;
  },
  setSurveys (state, payload) {
    state.surveys = payload;
  },
  addSurvey (state, payload) {
    state.surveys.unshift(payload);
  },  
  editSurvey (state, payload) {
    Object.assign(state.surveys[payload.index], payload.survey);
  },
  resetSurveys (state) {
    Object.assign(state, getDefaultState());
  },
  
};

const actions = {
  callSetSurveys (context, payload) {
    context.commit('setSurveys', payload);
  },
  callSelectedSurvey (context, payload) {
    context.commit('setSurvey', payload);
  },
  callAddSurvey (context, payload) {
    context.commit('addSurvey', payload);
  },
  callEditSurvey (context, payload) {
    context.commit('editSurvey', payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/surveys.js